<template>
  <dialog-email
    ref="dialog-email"
    :contentKey="contentKey"
    :contentMap="contentMap"
    :data="data"
    :isLoading="isLoading"
    @on-submit-email="handlerSubmit"
  />
</template>

<script>
import { createParams } from '@/utils/dynamic'
import { ModelEmailStatusRequest } from '@/models/RepairExchangeOrder'
import { api } from '@/services/api'
import { ServiceEmailMessages } from '@/services/email-messages'

export default {
  name: 'DialogStatusRequestEmail',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialogs' */ '@/components/Dialogs/DialogEmail/index')
  },
  data () {
    return {
      isLoading: false,
      id: null,
      subject: null,
      requestData: null,
      data: {},
      contentMap: {},
      cb: () => {}
    }
  },
  created () {
    this.$bus.$on('on-status-email-request-repair-order', this.show)
  },
  beforeDestroy () {
    this.$bus.$off('on-status-email-request-repair-order', this.show)
  },
  computed: {
    contentKey () {
      return 'status-request-email'
    }
  },
  methods: {
    loadData () {
      this.isLoading = true
      const params = createParams({
        select: [
          'id', 'baxpo as baxPO', 'part.partNumber as partNumber', 'partSN', 'lastInfo',
          'rfq2.supplierContact.name as salesOrderContactName', 'rfq2.supplierContact.email as supplierContactEmail'
        ].join(','),
        filter: `id == ${this.id}`
      })
      return api
        .get(`RepairExchangeOrderFollowUps/GetAllDynamic`, { params })
        .then(({ data }) => {
          if (data.value[0]) {
            this.requestData = data.value[0]
          } else {
            throw Error()
          }
        })
        .then(() => {
          this.createMapData()
          this.createEmailData()
        })
        .catch(err => {
          this.requestErrorHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createMapData () {
      this.contentMap = this.copyObjectProps(new ModelEmailStatusRequest(), {
        ...this.requestData,
        subject: this.subject
      })
    },
    createEmailData () {
      const { baxPO, supplierContactEmail } = this.requestData
      let subject = `${baxPO} ${this.L10n('status-request')}`
      let emailToList = []

      supplierContactEmail && emailToList.push(supplierContactEmail)

      this.data = {
        subject,
        emailToList
      }
    },
    show ({ subject, id }, cb) {
      this.cb = cb
      this.id = id
      this.subject = subject

      this.$refs['dialog-email'].show()
      this.loadData()
    },
    hide () {
      this.$refs['dialog-email'].hide()
      this.isLoading = false
    },
    handlerSubmit (data) {
      this.isLoading = true
      ServiceEmailMessages.send(data)
        .then(() => {
          if (typeof this.cb === 'function') {
            this.cb({ ...data, supplierContactName: this.contentMap.salesOrderContactName })
          }
          this.hide()
        })
        .catch((err) => {
          this.isLoading = false
          this.requestErrorHandler(err)
        })
    }
  }
}
</script>
